<template>
    <div class="multify-uploader-wraper">
        <ButtonGroup>
            <Button icon="md-cloud-upload" type="primary" @click="upload">{{uploadTitle}}</Button>
            <Button icon="md-folder-open" type="info" @click="showPanel">显示</Button>
        </ButtonGroup>
        <div class="global-uploader" ref="globalUploader" :style="{'top': `${tableOffsetHeight}px`}">
            <!-- 上传 -->
            <uploader
                    ref="uploader"
                    :options="options"
                    :autoStart="true"
                    :file-status-text="statusText"
                    @file-added="onFileAdded"
                    @file-success="onFileSuccess"
                    @file-progress="onFileProgress"
                    @file-error="onFileError"
                    class="uploader-app">
                <uploader-unsupport></uploader-unsupport>

                <uploader-btn :id="`${businessProperty}-uploader-btn`" :attrs="attrs" :single="single" ref="uploadBtn">选择文件</uploader-btn>

                <uploader-list v-show="panelShow">
                    <div class="file-panel" slot-scope="props" :class="{'collapse': collapse}">
                        <div class="file-title">
                            <h4>文件列表</h4>
                            <div class="operate">
                                <!--<Button @click="fileListShow"
                                        type="text"
                                        :title="collapse ? '展开':'折叠' "
                                        :icon="collapse ? 'md-expand': 'ios-arrow-down'">
                                </Button>-->
                                <Button @click="close" type="text" title="关闭" icon="md-close">
                                </Button>
                            </div>
                        </div>

                        <ul class="file-list">
                            <li v-for="file in props.fileList" :key="file.id">
                                <uploader-file :class="'file_' + file.id" ref="files" :file="file" :list="true"></uploader-file>
                            </li>
                            <div class="no-file" v-if="!props.fileList.length"><i class="iconfont icon-empty-file"></i> 暂无待上传文件</div>
                        </ul>
                    </div>
                </uploader-list>
            </uploader>
        </div>
    </div>
</template>

<script>
    import $ from 'jquery';
    import { deleteFileById } from "@api/admin.js";
    export default {
        name: "mult-uploader",
        props: {
            businessId:{
                type: String,
                default: ""
            },
            tempId:{
                type: String,
                default: ""
            },
            businessType:{
                type: String,
                default: "",
            },
            businessProperty:{
                type: String,
                default: ""
            },
            basedictStorage:{
                type: String,
                default: "localServer"
            }, //上传后存储的位置
            single:{
                type:Boolean,
                default:false
            },  //是否单选
            uploadTitle:{
                type: String,
                default: "上传"
            },  //更改上传按钮的内容
            fileList:{
                type:Array,
                default:[]
            },
            thumbWidth:{
                type: Number,
                default: ""
            }, //只适用于图片，是否有缩略图
            maxWidth:{
                type: Number,
                default: ""
            }, //只适用于图片，是否对上传的图片处理
            maxHeight:{
                type: Number,
                default: ""
            }, //只适用于图片，是否对上传的图片处理
            isNeed:{
                type:Boolean,
                default:false
            },  //是否需要验证
            isNeedInfo:{
                type:String,
                default:""
            },
            parentNodeId:{
                type:String,
                default:""
            },
            childCategory:{
                type:String,
                default:""
            }
        },
        data(){
            return {
                options: {
                    target: this.$store.state.sysApi+'/sys/file/uploadFileSlice',
                    testChunks: false,   //是否开启服务器分片校验
                    simultaneousUploads: 2, //并发上传数，默认3。
                    chunkSize: 10 * 1024 * 1024, //分块时按照该值来分。最后一个上传块的大小是可能是大于等于1倍的这个值但是小于两倍的这个值大小，默认 110241024。
                    forceChunkSize: false, //是否强制所有的块都是小于等于 chunkSize 的值
                    singleFile: this.single,
                    fileParameterName: 'file', //上传文件时文件的参数名，默认 file。
                    progressCallbacksInterval: 500,
                    speedSmoothingFactor: 0.1,
                    query: {
                        "businessType": this.businessType,
                        "businessId": this.businessId,
                        "tempId": this.tempId,
                        "businessProperty": this.businessProperty,
                        "basedictStorage": this.basedictStorage,
                        "thumbWidth":this.thumbWidth,
                        "maxWidth":this.maxWidth,
                        "maxHeight":this.maxHeight,
                        "parentNodeId":this.parentNodeId,
                        "childCategory":this.childCategory
                    },//其他额外的参数，这个可以是一个对象或者是一个函数，如果是函数的话，则会传入 Uploader.File 实例、当前块 Uploader.Chunk 以及是否是测试模式，默认为 {}。
                    headers: {},//额外的一些请求头，如果是函数的话，则会传入 Uploader.File 实例、当前块 Uploader.Chunk 以及是否是测试模式，默认 {}。
                    withCredentials: false,//标准的 CORS 请求是不会带上 cookie 的，如果想要带的话需要设置 withCredentials 为 true，默认 false。
                    preprocess: null, //可选的函数，每个块在测试以及上传前会被调用，参数就是当前上传块实例 Uploader.Chunk，注意在这个函数中你需要调用当前上传块实例的 preprocessFinished 方法，默认 null。
                    method: 'multipart',//当上传的时候所使用的是方式,可选 multipart、octet，默认 multipart
                    uploadMethod: 'POST', //真正上传的时候使用的 HTTP 方法，可以是字符串或者函数，如果是函数的话，则会传入 Uploader.File 实例、当前块 Uploader.Chunk，默认 POST。
                    prioritizeFirstAndLastChunk: false, //对于文件而言是否高优先级发送第一个和最后一个块。一般用来发送到服务端，然后判断是否是合法文件；例如图片或者视频的 meta 数据一般放在文件第一部分，这样可以根据第一个块就能知道是否支持；默认 false。
                    allowDuplicateUploads: false,// 是否允许重复上传，如果说一个文件以及上传过了是否还允许再次上传。默认的话如果已经上传了，除非你移除了否则是不会再次重新上传的，所以也就是默认值为 false。
                    generateUniqueIdentifier: null,
                    maxChunkRetries: 0,
                    chunkRetryInterval: null,
                    permanentErrors: [404, 415, 500, 501],
                    successStatuses: [200, 201, 202],
                    onDropStopPropagation: false,
                    initFileFn: null,
                    checkChunkUploadedByResponse: null,

                    /**
                     * 格式化剩余时间。以下代码把英文时间转成中文：
                     * @param timeRemaining
                     * @param parsedTimeRemaining
                     * @returns {*}
                     */
                    parseTimeRemaining: function (timeRemaining, parsedTimeRemaining) {
                        return parsedTimeRemaining
                            .replace(/\syears?/, '年')
                            .replace(/\days?/, '天')
                            .replace(/\shours?/, '小时')
                            .replace(/\sminutes?/, '分钟')
                            .replace(/\sseconds?/, '秒')
                    },

                },
                attrs: {
                    accept: "image/*",
                },
                statusText: {
                    success: '成功了',
                    error: '出错了',
                    uploading: '上传中',
                    paused: '暂停中',
                    waiting: '等待中'
                },
                panelShow: false,   //选择文件后，展示上传panel
                collapse: true,
                tableOffsetHeight:"",
            }
        },
        computed: {
            //Uploader实例
            uploader() {
                return this.$refs.uploader.uploader;
            },
        },
        mounted(){

        },
        methods:{
            /**
             * 点击上传按钮
             */
            upload(){
                if(this.isNeed){
                    if(this.options.query.businessId){
                        $("#"+this.businessProperty+"-uploader-btn").click();
                    }else{
                        this.$Message.info(this.isNeedInfo);
                    }
                }else{
                    $("#"+this.businessProperty+"-uploader-btn").click();
                }
            },
            showPanel(){
                this.panelShow = !this.panelShow;
            },
            /**
             *  这个事件一般用作文件校验，如果说返回了 false，那么这个文件就会被忽略，不会添加到文件上传列表中。
             * @param file
             */
            onFileAdded(file) {
                this.panelShow = true;
                //console.log(file);
            },
            /**
             * 一个文件在上传中，文件上传的过程中会频繁调用该函数
             * @param rootFile
             * @param file
             * @param chunk
             */
            onFileProgress(rootFile, file, chunk) {
                //console.log(`上传中 ${file.name}，chunk：${chunk.startByte / 1024 / 1024} ~ ${chunk.endByte / 1024 / 1024}`)
            },
            /**
             * 所有分片上传完成的回调，需要注意的是，由于异步上传，每一次分片上传不会等上一次响应回来才发送，
             * 因此该上传成功的回调时，返回的分片响应可能不是最后一片，因此后续会发送合并请求告诉后台进行合并文件
             * 第一个参数 rootFile 就是成功上传的文件所属的根 Uploader.File 对象，它应该包含或者等于成功上传文件；
             * 第二个参数 file 就是当前成功的 Uploader.File 对象本身；
             * 第三个参数就是 message 就是服务端响应内容，永远都是字符串；
             * 第四个参数 chunk 就是 Uploader.Chunk 实例，它就是该文件的最后一个块实例，如果你想得到请求响应码的话，chunk.xhr.status 就是
             * @param rootFile
             * @param file
             * @param response
             * @param chunk
             */
            onFileSuccess(rootFile, file, response, chunk) {
                let fileJsonObj = $.parseJSON(response);
                let fileData = fileJsonObj.data.data;
                this.fileList.push(fileData);
                //this.$emit('update:fileList', this.fileList);
                //上传完文件后
                this.$emit("save-check",fileData);
            },
            /**
             * 一个根文件（文件夹）成功上传完成。
             */
            fileComplete() {
                //console.log(this.fileList);
            },
            /**
             * 文件上传出错的回调
             * @param rootFile
             * @param file
             * @param response
             * @param chunk
             */
            onFileError(rootFile, file, response, chunk) {
                this.$Message({
                    message: response,
                    type: 'error'
                })
            },
            /**
             * 关闭panel
             */
            close() {
                this.panelShow = false;
            },
            fileListShow() {
                let $list = $('#global-uploader .file-list');

                if ($list.is(':visible')) {
                    $list.slideUp();
                    this.collapse = true;
                } else {
                    $list.slideDown();
                    this.collapse = false;
                }
            },
            /**
             * 计算table的高度
             * @param flag
             */
            calculateTableHeight(flag){
                let docHeight = document.documentElement.clientHeight; //可见区域的高度
                /**
                 * 只能是元组件才有的方法
                 * 距离父组件的高度
                 * @type {number}
                 */
                let queryOffsetTop = 0;
                if(this.$refs.globalUploader){
                    queryOffsetTop = this.$refs.globalUploader.getBoundingClientRect().top;
                }
                //alert(docHeight - queryOffsetTop - 180);
                this.tableOffsetHeight = docHeight - queryOffsetTop - 180;

            },
        },
        mounted(){
            this.$nextTick(() => {
                this.calculateTableHeight();
            })
        },
        watch:{
            businessId(val){
                this.options.query.businessId = val;
            },
            tempId(val){
                this.options.query.tempId = val;
            },
            basedictStorage(val){
                this.options.query.basedictStorage = val;
            }
        }
    }
</script>

<style scoped lang="scss">
    .global-uploader {
        position: absolute;
        right: 15px;
        z-index:1000;

        .uploader-app {
            width: 520px;
            .uploader-btn{
                display:none;
            }
        }

        .file-panel {
            background-color: #fff;
            border: 1px solid #e2e2e2;
            border-radius: 7px 7px 0 0;
            box-shadow: 0 0 10px rgba(0, 0, 0, .2);

            .file-title {
                display: flex;
                height: 30px;
                line-height: 30px;
                padding: 0 15px;
                border-bottom: 1px solid #ddd;

                .operate {
                    flex: 1;
                    text-align: right;
                }
            }

            .file-list {
                position: relative;
                height: 150px;
                overflow-x: hidden;
                overflow-y: auto;
                background-color: #fff;

                > li {
                    background-color: #fff;
                    /deep/ .uploader-file{
                        height: 30px;
                        line-height: 30px;
                    }
                }
            }

            &.collapse {
                .file-title {
                    background-color: #E7ECF2;

                }
            }
        }

        .no-file {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            font-size: 14px;
        }

        /deep/.uploader-file-icon {
            &:before {
                content: '' !important;
            }

            &[icon=image] {
                background: url(../image/image-icon.png);
                margin-top: 2px;
            }
            &[icon=video] {
                background: url(../image/video-icon.png);
                margin-top: 2px;
            }
            &[icon=document] {
                background: url(../image/text-icon.png);
                margin-top: 2px;
            }
        }

        /deep/.uploader-file-actions > span {
            margin-right: 6px;
            margin-top:5px;
        }
    }

    /* 隐藏上传按钮 */
    #global-uploader-btn {
        position: absolute;
        clip: rect(0, 0, 0, 0);
    }

</style>

